import { usePublicApiClient } from '@guiker/react-framework'
import { PublicApiClient } from '@guiker/user-enquiry-shared'

export const useUserEnquiryApiClient = usePublicApiClient(PublicApiClient)
